<script>
  export default {
    data() {
      return {
        errorMessage: '',
        errorMessageVisible: false,
      }
    },
    methods: {
      showErrorMessage(errorMessage, errorCode) {
        if (errorCode) {
          this.errorMessage = errorMessage + ' Foutcode: ' + errorCode;
        } else {
          this.errorMessage = errorMessage
        }
        this.errorMessageVisible = true
      },
      handleHttpError(error, defaultMessage) {
        if (error.response) {
          console.log(error.response)
          if (error.response.data.message) {
            this.showErrorMessage(error.response.data.message, error.response.data.errorCode)
            return
          }
        }

        this.showErrorMessage(defaultMessage, null);
      }
    }
  }
</script>
